'use client'

import { type ReactNode } from 'react'
import { trackComprehensiveEngagement } from './ComprehensiveAnalyticsClient'

interface ComprehensiveTrackedLinkClientProps {
  href: string
  children: ReactNode
  className?: string
  ariaLabel?: string
  componentName: Parameters<typeof trackComprehensiveEngagement>[0]
  ctaText: string
  openInNewTab?: boolean
}

export const ComprehensiveTrackedLinkClient = ({
  href,
  children,
  className,
  ariaLabel,
  componentName,
  ctaText,
  openInNewTab = false,
}: ComprehensiveTrackedLinkClientProps) => (
  <a
    href={href}
    aria-label={ariaLabel}
    className={className}
    onClick={event => {
      if (openInNewTab) {
        event.preventDefault()
        window.open(href, '_blank', 'noopener,noreferrer')
      }

      void trackComprehensiveEngagement(componentName, ctaText, href)
    }}>
    {children}
  </a>
)
